import React from 'react';
import HeaderNavigationDropdown from './HeaderNavigationDropdown';
import HeaderNavigationName from './HeaderNavigationItemName';
import { useDispatch } from 'react-redux';
import { setNavigationItemHover } from 'store/slices/UI-Slice';
import { useLocation } from 'react-router-dom';

const HeaderNavigationItem = ({ category }) => {
    const location = useLocation();

    const [opened, setOpened] = React.useState(false);
    const handleClickMobile = () => setOpened(!opened);
    const dispatch = useDispatch();

    const handleMouseOver = () => dispatch(setNavigationItemHover(true));
    const handleMouseLeave = () => dispatch(setNavigationItemHover(false));

    React.useEffect(() => {
        setOpened(false);
    }, [location]);

    return (
        <div className="navigation-item" onMouseOver={handleMouseOver} onMouseLeave={handleMouseLeave}>
            <HeaderNavigationName
                mobileClassName={opened ? 'opened' : ''}
                onClickMobile={handleClickMobile}
                link={category.link}
                name={category.name}
                hasList={!!category.items}
            />
            {category.items && <HeaderNavigationDropdown button={category.button} items={category.items} />}
        </div>
    );
};

export default HeaderNavigationItem;
